import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarBlank } from "@phosphor-icons/react";
import { toISO, fromISO, todayISO } from "./constants";

export function DatePicker({ label, value, onChange, minToday = false }) {
  const [open, setOpen] = useState(false);
  const min = minToday ? new Date(todayISO() + "T00:00:00") : undefined;
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider">{label}</Label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="w-full mt-1 justify-start gap-2 font-normal" data-testid={`dp-${label.replace(/\s/g, "")}`}>
            <CalendarBlank size={14} className="text-zinc-500" />
            {value || "Selecciona..."}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={value ? fromISO(value) : undefined}
            onSelect={(d) => { if (d) { onChange(toISO(d)); setOpen(false); } }}
            disabled={(d) => minToday && d < min}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
